export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    SortType["DATA"] = "DATA";
    SortType["ALPHA"] = "ALPHA";
    SortType["FIELD"] = "FIELD";
    SortType["NESTED"] = "NESTED";
    SortType["MANUAL"] = "MANUAL";
})(SortType || (SortType = {}));
